import React, { useEffect } from 'react'

const withFormResets = WrappedComponent => {
  return props => {
    const {
      setCamperForm, // via redux actions
      setParentForm, // via redux actions
      setEmergencyContactForm, // via redux actions
      setPickupPersonForm // via redux actions
    } = props

    useEffect(() => {
      setCamperForm(null)
      setParentForm(null)
      setEmergencyContactForm(null)
      setPickupPersonForm(null)
    }, [])

    return <WrappedComponent {...props} />
  }
}

export default withFormResets
